    import Overlay from './Overlay';

    let gameScale;
    let overlayGraphics;
    let soundIcon;
    let thisX;
    let thisY;
    let thisWidth;
    let sounds;
    let xmlLoader;
    let domTitle;
    let padding;
    let numPages;
    let thisPage;
    let domCounter;

    export default class Dictionary extends Overlay {
        constructor() {
            super('dictionary');
        }

        create() {
            gameScale = this.registry.get('scaleIt');
            thisX = 430 * gameScale;
            thisY = 165 * gameScale;
            thisWidth = 285 * gameScale;
            thisPage = 1;
            padding = this.registry.get('padding') / 2;
            sounds = this.scene.get('sounds');
            xmlLoader = this.scene.get('xmlLoader');

            super.create();
        }

        active() {
            xmlLoader.events.once('changeSpeech', super.closeGuide, this);
            super.shareVariables();
            //textStyle = domTitle.node.style;
            //origColour = textStyle.color;
            thisPage = 1;
            this.createIcon();
            this.tintButtons();
            this.createCounter();

            super.active();
            //dictionaryBG

        }



        updateTextPosition() {
            super.updateTextPosition({
                x: thisX,
                y: thisY,
                width: thisWidth,
                class: 'dictionary'
            });

            this.updateDictionary();
        }

        updateDictionary() {
            domTitle = this.domTitle;
            soundIcon.x = thisX;
            soundIcon.y = thisY;
            domTitle.x += soundIcon.width + padding;
            thisPage = xmlLoader.getThisSpeech();
            //domCounter.setText(thisPage + " / " + numPages);
            domCounter.node.innerHTML = (thisPage + 1) + "/" + numPages;

        }

        onIcon() {
            //super.shareVariables();
            soundIcon.setTintFill(0x990000);
            //textStyle.color = '#990000';
            //this.domTitle.setTint(0x990000);
            let id = xmlLoader.getAttribute('id');
            sounds.blipBloop(id);
        }

        outIcon() {
            soundIcon.clearTint();
            //textStyle.color = origColour;
            //331800
        }

        createIcon() {
            let utils = this.scene.get('utils');
            soundIcon = utils.addImage(this, {
                id: 'dictIcon'
            });

            soundIcon.setInteractive({
                useHandCursor: true
            });

            soundIcon.on('pointerover', this.onIcon);
            soundIcon.on('pointerout', this.outIcon);
            soundIcon.input.hitArea.setSize(soundIcon.width + padding, soundIcon.height)

            /*

               this.btn.setInteractive({
                   useHandCursor: true,
                   hitArea: new Phaser.Geom.Rectangle(this.btn.width / 2 + rect.width, 0, this.btn.width, this.btn.height),
                   hitAreaCallback: Phaser.Geom.Rectangle.Contains

               });

            domTitle.setInteractive({
                useHandCursor: true,
                hitArea: Phaser.Geom.Rectangle(0, 0, 400, 400),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains,
            });


            domTitle.on('pointerover', this.onIcon);
            domTitle.on('pointerout', this.outIcon);
            //domTitle.input.hitArea.setSize(domTitle.width, soundIcon.height);
*/
        }

        createCounter() {
            numPages = xmlLoader.getSpeechLength();
            domCounter = this.add.dom(0, 0).createFromHTML('');
            let textStyle = domCounter.node.style;

            textStyle.fontSize = 20 * gameScale + 'px';
            domCounter.setClassName('dictionary');
            domCounter.x = 535 * gameScale; //thisX + thisWidth / 2 - domCounter.width;
            domCounter.y = 453 * gameScale;

            domCounter.updateSize();

        }

        tintButtons() {
            overlayGraphics = this.scene.get('overlayGraphics');
            overlayGraphics.getNext().setTintFill(0x331800);
            overlayGraphics.getBack().setTintFill(0x331800);
        }

    }